import { useEffect, useState } from 'react';
import styles from '../styles/styles.module.css';
import { tokens } from '../utils/design-tokens';

interface ToastProps {
  message: string;
  show: boolean;
  duration?: number;
}

export function Toast({ message, show, duration = 2000 }: ToastProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (show && message) {
      setShouldRender(true);
      // Trigger animation after a brief delay to ensure DOM is ready
      const timer = setTimeout(() => setIsVisible(true), 10);
      
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
        // Remove from DOM after animation completes
        setTimeout(() => setShouldRender(false), 300);
      }, duration);
      
      return () => {
        clearTimeout(timer);
        clearTimeout(hideTimer);
      };
    } else {
      setIsVisible(false);
      if (!show) {
        const timer = setTimeout(() => setShouldRender(false), 300);
        return () => clearTimeout(timer);
      }
    }
  }, [show, message, duration]);

  if (!shouldRender || !message) return null;

  return (
    <div
      className="relative pointer-events-none"
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.3s ease-out, transform 0.3s ease-out',
      }}
    >
      <div
        className="relative"
        style={{
          backgroundColor: 'var(--color-bg-secondary)',
          borderRadius: tokens.radius('sm'),
          padding: `${tokens.space('sm')} ${tokens.space('md')}`,
          boxShadow: 'var(--shadow-modal)',
          border: `1px solid var(--color-text-default)`,
        }}
      >
        <p
          className={`${styles.inconsolataBodyXS} relative shrink-0 text-nowrap whitespace-pre`}
          style={{ color: 'var(--color-text-default)' }}
        >
          {message}
        </p>
      </div>
    </div>
  );
}

